import { render, staticRenderFns } from "./CoachingSessionsList.vue?vue&type=template&id=b29089dc"
import script from "./CoachingSessionsList.vue?vue&type=script&lang=js"
export * from "./CoachingSessionsList.vue?vue&type=script&lang=js"
import style0 from "./CoachingSessionsList.vue?vue&type=style&index=0&id=b29089dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports